export const signOut = (): void => {
  localStorage.removeItem('session_token');
};

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('session_token');
  return !!token;
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('session_token', token);
};